import { isNumber } from 'lodash';

interface LinkLimitations {
  limitations_source?: { from: number | string; to: number | string };
  limitations_target?: { from: number | string; to: number | string };
}

const formatBound = (value: unknown, fallback: number | string) =>
  isNumber(value) ? value : fallback;

/** Bounds displayed on the TQL graph and in dependency edge choices. */
export function getTQLLinkBounds(data: LinkLimitations | undefined) {
  return {
    sourceFrom: data?.limitations_source
      ? formatBound(data.limitations_source.from, '*')
      : 1,
    sourceTo: formatBound(data?.limitations_source?.to, '*'),
    targetFrom: data?.limitations_target
      ? formatBound(data.limitations_target.from, '*')
      : 1,
    targetTo: formatBound(data?.limitations_target?.to, '*'),
  };
}
